// src/ConsumerApp/api/addresses/deliveryAddress.service.js
import { apiClient } from '../apiClient';

export const DeliveryAddressService = {
  getDeliveryAddresses: async (customerId) => {
    const response = await apiClient.get(
      `/brickbucket/customer/delivery-address/getDeliveryAddresses?customer_id=${customerId}`
    );
    return response.data || response;
  },

  getDeliveryAddressById: async (addressId) => {
    const response = await apiClient.get(
      `/brickbucket/customer/delivery-address/getDeliveryAddressById?address_id=${addressId}`
    );
    return response.data || response;
  },

  createDeliveryAddress: async (payload) => {
    const response = await apiClient.post(
      `/brickbucket/customer/delivery-address/createDeliveryAddress`,
      payload
    );
    return response.data || response;
  },

  updateDeliveryAddress: async ({ addressId, payload }) => {
    const response = await apiClient.put(
      `/brickbucket/customer/delivery-address/updateDeliveryAddress?address_id=${addressId}`,
      payload
    );
    return response.data || response;
  },

  deleteDeliveryAddress: async (addressId) => {
    const response = await apiClient.delete(
      `/brickbucket/customer/delivery-address/deleteDeliveryAddress?address_id=${addressId}`
    );
    return response.data || response;
  },
};